// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"921b0281","56":"a38ced2d","194":"db447f81","545":"db447f81","674":"921b0281"}[chunkId] + ".chunk.css";
};